<template>
    <div>
        <div class="product-page-container"
            :style="{ overflowX: 'hidden', borderRadius: '10px', background: '#fff', paddingLeft: '8px', paddingRight: '8px', overflowY: 'auto', height: tableHeight + 'px' }">
            <div v-loading="loading" class="loading-wrapper">
                <div v-if="!loading && (!tableData || tableData.length === 0)" class="empty-data-box"
                    :style="{ height: tableHeight - 10 + 'px' }">
                    <el-empty description="暂无数据" :image-size="120">
                        <template #description>
                            <div class="empty-title">暂无数据</div>
                            <div class="empty-subtitle">换个关键词试试，可能会有新发现</div>
                        </template>
                    </el-empty>
                </div>
                <el-row v-else :gutter="20">
                    <el-col v-for="(item, index) in tableData" :key="index" :xs="24" :sm="12" :md="8" :lg="6" :xl="6"
                        class="mb-20">
                        <div class="product-card" @click="rowClick(item)" @dblclick="rowDblclick(item)">
                            <div class="card-img-box">
                                <el-image :src="item.img.length ? item.img[0] : require('@/assets/img/error_ch.png')"
                                    :fit="item.img.length ? 'cover' : 'contain'" 
                                    :class="{'has-no-image': !item.img.length}"
                                    @click.prevent="preview(item, item.img)" loading="lazy">
                                    <template #error>
                                        <div class="image-viewer-slot image-slot">
                                            <el-icon><icon-picture /></el-icon>
                                        </div>
                                    </template>
                                </el-image>
                                <div class="status-tags" v-if="item.stock_type_txt_list?.length">
                                    <span v-for="(tag, i) in item.stock_type_txt_list" :key="i" class="tag"
                                        :class="[tag == '二手' || tag == '过保' || tag == '包附破损' ? 'tag-warning' : 'tag-info']">
                                        {{ tag }}
                                    </span>
                                </div>
                                
                                   <el-tag v-if="item.isbadge == 1" size="small"
                                    class="verified-tag-topright">已核实</el-tag>
                            </div>

                            <div class="card-info">
                                
                                <el-tag v-if="filter && [item.brand_name?.toLowerCase(), item.name?.toLowerCase(), item.model?.toLowerCase(), item.order_no?.toLowerCase()].includes(filter.toLowerCase())" type="success" size="small"
                                    class="stamp-tag">精准匹配</el-tag>
                                    <el-tag v-else-if="item.issus == 1" type="danger" size="small"
                                    class="stamp-tag">疑似关联</el-tag>
                                <el-tag v-if="false" type="danger" size="small"
                                    class="stamp-tag verified-tag">已核实</el-tag>
                                <div style="display: flex;">
                                    <div class="brand-product-wrapper">
                                        <div class="brand-name">{{ item.brand_name }}</div>
                                        <div class="product-name">{{ item.name }}</div>
                                    </div>
                                    <div v-if="item.type_name" class="type-row">
                                        <span class="type-tag">
                                            <span class="attr-label">类型</span>：{{ item.type_name }}
                                        </span>
                                    </div>
                                </div>


                                <div class="attrs-price-wrapper">
                                    <div class="product-attrs">
                                        <div class="attrs-row">
                                            <span class="attr-item">
                                                <span class="attr-label">型号</span>：{{ item.model }}
                                            </span>
                                        </div>
                                        <div class="attrs-row">
                                            <span class="attr-item">
                                                <span class="attr-label">订货号</span>：{{ item.order_no }}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <div class="price-stock-row">
                                        <div class="price" style="text-align: right;">
                                            <el-tooltip placement="left">
                                                <template #content>
                                                   此信息由用户提供，仅供参考，请与发布用户核实！
                                                  <!-- <span v-if="item.product_time"> <br />
                                                    列表年份：{{ item.product_time }}</span>
                                                    <br />
                                                    列表价：{{ item.price }}
                                                    <br />
                                                    折扣：{{ item.tsw_discount }}
                                                    <br />
                                                    单价：{{ item.tsw_price }} -->
                                                </template>
                                                <span>￥{{ item.tsw_price }}</span>
                                            </el-tooltip>
                                        </div>

                                        <div class="stock stock-large" style="text-align: right;">
                                       <!-- <span
                                            style="width: 2.25rem;margin-right: 0.25rem;text-justify: inter-character;display: inline-block;text-align-last: justify;">库存</span>： -->
                                        <span class="stock-value">{{ item.sur_num }}</span>
                                        <span v-if="item.unit" class="stock-unit">/{{ item.unit }}
                                        </span>
                                    </div>
                                    </div>
                                    
                                </div>
                                <div class="">
                                    <div class="product-attrs">

                                        <div class="attrs-row">
                                            <span class="attr-item">
                                                <span class="attr-label">备注</span>：{{ item.remark }}
                                            </span>
                                        </div>
                                    </div>


                                </div>
                                <div class="num-chat-row" @click.stop @dblclick.stop>
                                    
                                    <el-input-number  v-model="item.num_input" :min="1"
                                        :max="item.sur_num" @change="handleChange" size="small" v-if="item.isbadge == 1"/>
                                    <el-icon size="28" @click.stop="addToCart(item, $event)" v-if="item.isbadge == 1" style="color:#ff8a5c; margin-left: 0.1rem;">
                                        <ShoppingCartFull />
                                    </el-icon>
                                   
                                    <div style="display: flex; margin-left: auto; gap: 0.5rem;">
                                         <img v-if="item.is_open == 1" :src="require('@/assets/img/phone-o.png')" @click.stop="showContact(item)"
                                            style="width: 28px; height: 28px; cursor: pointer;">
                                        <img :src="require('@/assets/img/iconPark-comment .png')" @click.stop="chat_click(item.id)"
                                            style="width: 28px; height: 28px; cursor: pointer;">
                                    </div>


                                    <!-- <TooltipComponent :id="item.id" @chat-click="chat_click" @preview="preview"
                                        style="margin-left: auto;">
                                    </TooltipComponent> -->
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

        </div>
        <examineImg ref="examineImg"></examineImg>
        <chat ref="chat" v-if="chat_info" v-on:closeChat="closeChat($event)"></chat>
        <el-dialog
            v-model="contact_info"
            width="380px"
            :close-on-click-modal="false"
            class="contact-dialog"
            :show-close="false"
        >
            <template #header>
                
            </template>
            <div v-if="current_contact" class="contact-content">
                <div class="contact-card">
                    <div class="contact-avatar">
                        <div class="avatar-circle">
                            <el-icon :size="48"><User /></el-icon>
                        </div>
                    </div>
                    <div class="contact-name">{{ current_contact.user_linkman || '未知联系人' }}</div>
                </div>
                <div class="contact-info-list">
                    <div class="info-item">
                        <div class="info-icon-wrapper">
                            <el-icon><User /></el-icon>
                        </div>
                        <div class="info-detail">
                            <div class="info-tag">联系人</div>
                            <div class="info-text">{{ current_contact.user_linkman || '-' }}</div>
                        </div>
                    </div>
                    <div class="info-item" @click="copyPhone">
                        <div class="info-icon-wrapper phone-icon">
                            <el-icon><Phone /></el-icon>
                        </div>
                        <div class="info-detail">
                            <div class="info-tag">电话</div>
                            <div class="info-text phone-text">
                                {{ current_contact.user_mobile || current_contact.phone || '-' }}
                            </div>
                        </div>
                        <div class="copy-hint">点击复制</div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button class="close-btn" @click="contact_info = false">关闭</el-button>
                    <el-button v-if="current_contact?.user_mobile || current_contact?.phone" class="copy-btn" type="primary" @click="copyPhone">
                        <el-icon><DocumentCopy /></el-icon>
                        复制号码
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import '../../assets/search/index.css'
import { ElMessage } from 'element-plus'
import { ShoppingCart, ShoppingCartFull, ChatDotSquare, Phone, User, OfficeBuilding, DocumentCopy, UserFilled } from '@element-plus/icons-vue'
import examineImg from '../public/img'
import chat from '../public/chat'
import TooltipComponent from './tooltip.vue'

export default {
    name: 'Index2Component',
    components: { examineImg, chat, TooltipComponent, ShoppingCart, ShoppingCartFull, ChatDotSquare, Phone, User, OfficeBuilding, DocumentCopy, UserFilled },
    props: {
        tableData: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        user_id: {
            type: String,
            default: ''
        },
        tableHeight: {
            type: Number,
            default: 500
        },
        filter: {
            type: String,
            default: ''
        },
        showCart: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            chat_info: false,
            contact_info: false,
            current_contact: null,
            index: [],
            srcList: []
        }
    },
    mounted() {

    },
    methods: {
        addToCart(item, event) {
            
            
            if (this.showCart) {
            this.$emit('update-cart-count', item)
                this.createFlyAnimation(event)
            }
            
            //ElMessage.success('已加入购物车')
        },
        createFlyAnimation(event) {
            const cartIcon = event.target
            const rect = cartIcon.getBoundingClientRect()
            
            const flyItem = document.createElement('div')
            flyItem.style.cssText = `
                position: fixed;
                width: 40px;
                height: 40px;
                background: #ff8a5c;
                border-radius: 50%;
                z-index: 9999;
                pointer-events: none;
                left: ${rect.left + rect.width / 2 - 20}px;
                top: ${rect.top + rect.height / 2 - 20}px;
                opacity: 1;
            `
            
            const cartIconElement = document.createElement('div')
            cartIconElement.innerHTML = '<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white"><path d="M832 312H264v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v136c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-40h168l40 400H184c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h664c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H536l-40-400h336c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z"></path></svg>'
            cartIconElement.style.cssText = 'display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;'
            flyItem.appendChild(cartIconElement)
            
            document.body.appendChild(flyItem)
            
            const sidebar = document.querySelector('.floating-sidebar')
            if (!sidebar) {
                setTimeout(() => {
                    document.body.removeChild(flyItem)
                }, 100)
                return
            }
            
            const cartItem = sidebar.querySelector('.sidebar-item:nth-child(1)')
            if (!cartItem) {
                setTimeout(() => {
                    document.body.removeChild(flyItem)
                }, 100)
                return
            }
            
            const offsetX = 50
            const offsetY = 100
            
            const cartItemRect = cartItem.getBoundingClientRect()
            const startX = rect.left + rect.width / 2
            const startY = rect.top + rect.height / 2
            const midX = cartItemRect.left - offsetX
            const midY = cartItemRect.top - offsetY
            const endX = cartItemRect.left + cartItemRect.width / 2 - 20
            const endY = cartItemRect.top + cartItemRect.height / 2 - 20
            
            const totalDuration = 500
            const phase1Ratio = 0.6
            
            let startTime
            
            const animate = (currentTime) => {
                if (!startTime) startTime = currentTime
                const elapsed = currentTime - startTime
                const progress = Math.min(elapsed / totalDuration, 1)
                
                let x, y, scale, opacity
                
                if (progress < phase1Ratio) {
                    const phase1Progress = progress / phase1Ratio
                    const t = phase1Progress
                    const t2 = t * t
                    const t3 = t2 * t
                    const mt = 1 - t
                    const mt2 = mt * mt
                    const mt3 = mt2 * mt
                    
                    const controlX1 = startX + (midX - startX) * 0.3
                    const controlY1 = startY - 80
                    const controlX2 = startX + (midX - startX) * 0.7
                    const controlY2 = midY - 40
                    
                    x = mt3 * startX + 3 * mt2 * t * controlX1 + 3 * mt * t2 * controlX2 + t3 * midX
                    y = mt3 * startY + 3 * mt2 * t * controlY1 + 3 * mt * t2 * controlY2 + t3 * midY
                    scale = 1 - phase1Progress * 0.3
                    opacity = 1 - phase1Progress * 0.2
                } else {
                    const phase2Progress = (progress - phase1Ratio) / (1 - phase1Ratio)
                    const t = phase2Progress
                    const t2 = t * t
                    const t3 = t2 * t
                    const mt = 1 - t
                    const mt2 = mt * mt
                    const mt3 = mt2 * mt
                    
                    const controlX1 = midX + (endX - midX) * 0.2
                    const controlY1 = midY - 20
                    const controlX2 = midX + (endX - midX) * 0.8
                    const controlY2 = midY + (endY - midY) * 0.5
                    
                    x = mt3 * midX + 3 * mt2 * t * controlX1 + 3 * mt * t2 * controlX2 + t3 * endX
                    y = mt3 * midY + 3 * mt2 * t * controlY1 + 3 * mt * t2 * controlY2 + t3 * endY
                    scale = 0.7 - phase2Progress * 0.4
                    opacity = 0.8 - phase2Progress * 0.8
                }
                
                flyItem.style.left = x + 'px'
                flyItem.style.top = y + 'px'
                flyItem.style.transform = `scale(${scale})`
                flyItem.style.opacity = opacity
                
                if (progress < 1) {
                    requestAnimationFrame(animate)
                } else {
                    if (flyItem.parentNode) {
                        document.body.removeChild(flyItem)
                    }
                }
            }
            
            requestAnimationFrame(animate)
        },
        handleChange(val) { console.log(val) },
        rowClick(row) { this.index = [parseInt(row.index)] },
        closeChat() { this.chat_info = false },
        async chat_click(id) {
            await this.$axios.post('/api/yunsys.storage/addchat', { id }).then(res => {
                const d = res.data
                if (d.code !== 0) return ElMessage.error(d.msg)
                this.chat_info = false
                this.$nextTick(() => {
                    this.chat_info = true
                    this.$nextTick(() => {
                        if (this.$refs.chat) {
                            this.$refs.chat.dialogTableVisible = true
                            this.$refs.chat.pitch_id = d.data.data
                            this.$refs.chat.admin_pitch_id = d.data.data
                            this.$refs.chat.search()
                        }
                    })
                })
            }).catch(() => ElMessage.error('系统错误'))
        },
        preview(row, img) {
            if (!img || img.length === 0) return
            this.srcList = []
            img.forEach(i => this.srcList.push(i))
            this.$refs.examineImg.img_title = { ...row, associate: row.associate || [] }
            this.$refs.examineImg.data = this.srcList
            this.$refs.examineImg.dialogTableVisible = true
            this.$refs.examineImg.imgBigUrl = this.srcList[0]
        },
        rowDblclick(row) {
            const url = this.$router.resolve({ path: '/product', query: { id: row.id } }).href
            window.open(url, '_blank')
        },
        async showContact(item) {
            this.current_contact =item
                this.contact_info = true
        },
        copyPhone() {
            const phone = this.current_contact.user_mobile || this.current_contact.phone
            if (!phone) return
            navigator.clipboard.writeText(phone).then(() => {
               // ElMessage.success('电话号码已复制到剪贴板')
                ElMessage({
							message: '电话号码已复制到剪贴板',
							type: 'success',
							grouping: true // 开启合并功能
						})
            }).catch(() => {
                const textArea = document.createElement('textarea')
                textArea.value = phone
                document.body.appendChild(textArea)
                textArea.select()
                document.execCommand('copy')
                document.body.removeChild(textArea)
                ElMessage.success('电话号码已复制到剪贴板')
            })
        }
    }
}
</script>

<style lang="less" scoped>
.product-page-container {
    position: relative;
    border-radius: 12px;
    box-shadow: 0 1px 10px rgba(0, 0, 0, 0.04);
    background: #fafbfc;
    scrollbar-width: thin !important;
    scrollbar-color: transparent transparent !important;
}

.product-page-container .el-loading-mask {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 100% !important;
    height: 100% !important;
    overflow: hidden !important;
    z-index: 9999 !important;
}

.loading-wrapper {
    position: static;
    min-height: 100%;
}

.empty-data-box {
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.empty-data-box :deep(.el-empty) {
    padding: 46px 0;
}

.empty-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    line-height: 24px;
}

.empty-subtitle {
    margin-top: 6px;
    font-size: 13px;
    color: #909399;
    line-height: 20px;
}

.product-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.28s ease;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.product-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
}

.card-img-box {
    position: relative;
    width: 100%;
    height: 180px;
    overflow: hidden;
}

:deep(.el-image) {
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 0.75rem;
}

:deep(.product-card .el-image.has-no-image) {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    background: #fdfdfd;
}

:deep(.product-card .el-image.has-no-image img) {
    max-width: 80px !important;
    max-height: 80px !important;
    width: auto !important;
    height: auto !important;
    object-fit: contain !important;
    position: static !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
}

.el-input-number--small {
    line-height: 1.375rem;
    width: 5.5rem;
    height: 1.8rem;

    :deep(.el-icon) {
        color: #000000 !important;
        transform: scale(1) !important;
    }
}

:deep(.product-card .el-image img) {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.status-tags {
    position: absolute;
    top: 8px;
    left: 8px;
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
}

.tag {
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 3px;
}

.tag-warning {
    color: red;
    background: #fff0e4;
}

.tag-info {
    color: #4bd4cd;
    background: #dffffb;
}

.issus-tag {
    position: absolute;
    bottom: 8px;
    right: 8px;
    z-index: 10;
}

.brand-product-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 40px;
    min-width: 0;
    overflow: hidden;
}

.type-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 40px;
    flex-shrink: 0;
}

.type-tag {
    font-size: 12px;
    color: #666;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.rzh-icon {
    width: 3.0rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 10px;
    right: 0;
}

.rzh-icon img {
    width: 35px;
    height: 35px;
    object-fit: contain;
}

.verified-text {
    font-size: 12px;
    color: red;
    text-align: center;
    margin-top: 2px;
}

.card-info {
    position: relative;
    padding: 12px;
    flex: 1;
    display: flex;
    flex-direction: column;
}
.verified-tag-topright {
    position: absolute;
  transform: translate(-50%,-50%) rotate(-15deg);
  z-index: 10;
  padding: .625rem .625rem;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: .25rem;
  bottom: 0;
  left: 84%;
  opacity: .65;
  border-width: .1875rem;
  border-style: dashed;
  color: #ff8a5c !important;
  background-color: #fff0e4 !important;
  border-color: #facc9e !important;
}

.contact-dialog {
    :deep(.el-dialog) {
        border-radius: 20px;
        overflow: hidden;
    }
    
    :deep(.el-dialog__header) {
        margin: 0;
        padding: 0;
    }
    
    :deep(.el-dialog__body) {
        padding: 0;
    }
    
    :deep(.el-dialog__footer) {
        padding: 16px 24px 24px;
    }
}

.dialog-header {
    background: linear-gradient(135deg, #ffb08c 0%, #ff9a6b 100%);
    padding: 24px;
    display: flex;
    align-items: center;
    gap: 12px;
}

.header-icon {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}

.header-title {
    font-size: 20px;
    font-weight: 600;
    color: white;
    letter-spacing: 0.5px;
}

.contact-content {
}

.contact-card {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 16px;
    padding: 28px 20px;
    text-align: center;
    margin-bottom: 24px;
    position: relative;
    overflow: hidden;
}

.contact-card::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%);
    border-radius: 50%;
}

.contact-avatar {
    position: relative;
    z-index: 1;
}

.avatar-circle {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #ffb08c 0%, #ff9a6b 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 16px;
    color: white;
    box-shadow: 0 8px 24px rgba(255, 176, 140, 0.4);
    animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
}

.contact-name {
    position: relative;
    z-index: 1;
    font-size: 22px;
    font-weight: 700;
    color: #2d3748;
    letter-spacing: 0.5px;
}

.contact-info-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.info-item {
    display: flex;
    align-items: center;
    padding: 18px 20px;
    background: #f8fafc;
    border-radius: 14px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 2px solid transparent;
    cursor: pointer;
    position: relative;
}

.info-item:hover {
    background: white;
    border-color: #ff8a5c;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(255, 138, 92, 0.15);
}

.info-icon-wrapper {
    width: 52px;
    height: 52px;
    background: linear-gradient(135deg, #ffb08c 0%, #ff9a6b 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    color: white;
    flex-shrink: 0;
}

.phone-icon {
    background: linear-gradient(135deg, #ffb08c 0%, #ff9a6b 100%);
}

.info-icon-wrapper .el-icon {
    font-size: 24px;
}

.info-detail {
    flex: 1;
}

.info-tag {
    font-size: 12px;
    color: #94a3b8;
    margin-bottom: 6px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.info-text {
    font-size: 17px;
    font-weight: 600;
    color: #1e293b;
    letter-spacing: 0.3px;
}

.phone-text {
    color: #ff9a6b;
}

.copy-hint {
    font-size: 11px;
    color: #ff9a6b;
    background: rgba(255, 176, 140, 0.1);
    padding: 4px 10px;
    border-radius: 6px;
    font-weight: 500;
    opacity: 0;
    transition: all 0.3s ease;
}

.info-item:hover .copy-hint {
    opacity: 1;
}

.dialog-footer {
    display: flex;
    gap: 12px;
}

.close-btn {
    flex: 1;
    border-radius: 10px;
    height: 44px;
    font-weight: 500;
    border-color: #e2e8f0;
    color: #64748b;
}

.close-btn:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
    color: #475569;
}

.copy-btn {
    flex: 2;
    border-radius: 10px;
    height: 44px;
    font-weight: 600;
    background: linear-gradient(135deg, #ffb08c 0%, #ff9a6b 100%);
    border: none;
    transition: all 0.3s ease;
}

.copy-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(255, 176, 140, 0.4);
}

.stamp-tag {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-15deg);
    opacity: 0.85;
    z-index: 10;
    border-width: 3px;
    border-style: dashed;
    padding: 10px 10px;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 4px;
}

.verified-tag {
    top: 50%;
}

.brand-name {
    font-weight: bold;
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
}

.product-name {
    font-size: 13px;
    color: #555;
    line-height: 1.4;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
}

.attrs-price-wrapper {
    display: flex;
    height: 40px;
    // margin-bottom: 10px;
}

.product-attrs {
    flex: 1;
    font-size: 12px;
    color: #888;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
}

.attrs-row {
    display: flex;
    margin-bottom: 4px;
    overflow: hidden;
}

.attr-item {
    flex: 1;
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.stock-value {
    font-size: 16px;
    font-weight: bold;
    color: #ff8a5c;
}

.stock-unit {
    display: inline;
    white-space: nowrap;
    font-size: 16px;
    font-weight: bold;
    color: #ff8a5c;
}

.attr-label {
    display: inline-block;
    width: 36px;
    text-align: justify;
    text-align-last: justify;
    margin-right: 4px;
    flex-shrink: 0;
    text-justify: inter-character;
}

.product-attrs div {
    margin-bottom: 5px;
}

.product-attrs span {
    color: #666;
    font-weight: 500;
}

.price-stock-row {
    flex-shrink: 0;
    min-width: 80px;
}

.stock-large {
    font-size: 12px !important;
    font-weight: 500 !important;
    color: #666 !important;
}

.num-chat-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #666;
}

.price {
    font-size: 16px;
    color: #ff8a5c;
    font-weight: bold;
}

.stock {
    font-size: 12px;
    color: #666;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
    background-color: #ff8a5c !important;
}

:deep(.el-input-group__append) {
    background: #ff8a5c;
}

:deep(.el-pager .number) {
    display: none
}

:deep(.el-pager .more) {
    display: none
}

.mb-20 {
    margin-bottom: 20px;
}

.product-page-container::-webkit-scrollbar {
    width: 6px !important;
    height: 6px !important;
}

.product-page-container::-webkit-scrollbar-thumb {
    background-color: #e5e6eb !important;
    border-radius: 6px !important;
    opacity: 0 !important;
    transition: all 0.2s ease !important;
}

.product-page-container:hover::-webkit-scrollbar-thumb {
    opacity: 1 !important;
    background-color: #c9cdd4 !important;
}

.product-page-container::-webkit-scrollbar-track {
    background: transparent !important;
}


.product-page-container:hover {
    scrollbar-color: #c9cdd4 transparent !important;
}

:deep(.el-table .el-table__cell) {
    border-right: none;
}
</style>
